import Vue from 'vue'

const state = {
  user: {
    uid: '',
    name: '',
    isHost: false,
    company: '',
    email: ''
  },
  conference: {
    id: '',
    hostName: '',
    hostId: '',
    topic: ''
  },
  participants: {
    // schema
    // [uid: string]:{
    //   key: string,
    //   name: string,
    //   role: 'host' | 'audience' | 'presenter',
    //   status: 'online' | 'offline',
    //   stream: boolean,
    //   video: boolean,
    //   audio: boolean,
    //   email: string,
    //   company: string
    // }
  },
  panelState: {
    chat: false,
    participant: true,
    audio: false,
    video: false,
    share: false,
    mediaDevice: false
  },
  chatMessages: [],
  agoraClient: {
    rtm: null,
    rtc: {}
  }
}

const getters = {
  user: state => state.user,
  conference: state => state.conference,
  presenters: state => {
    return Object.values(state.participants)
      .filter(p => p.status === 'online')
      .filter(p => p.role === 'presenter' || p.role === 'host')
      .reduce((acc, curr) => {
        return curr.role === 'host' ? [curr, ...acc] : [...acc, curr]
      }, [])
  },
  audiences: state => {
    return Object.values(state.participants)
      .filter(p => p.status === 'online')
      .filter(p => p.role === 'audience')
  },
  panelState: state => state.panelState,
  chatMessages: state => state.chatMessages,
  rtm: state => state.agoraClient.rtm,
  rtc: state => state.agoraClient.rtc,
  participants: state => state.participants
}

const actions = {
  setUserInfo ({ commit }, data) {
    commit('SET_USER_INFO', data)
  },
  setConferenceInfo ({ commit }, data) {
    commit('SET_CONFERENCE_INFO', data)
  },
  updatePanelState ({ commit }, data) {
    commit('UPDATE_PANEL_STATE', data)
  },
  appendChatMessage ({ commit }, data) {
    commit('APPEND_CHAT_MESSAGE', data)
  },
  initAgoraClient ({ commit }, data) {
    commit('INIT_AGORA_CLIENT', data)
  },
  addParticipant ({ commit }, data) {
    commit('ADD_PARTICIPANT', data)
  },
  deleteParticipant ({ commit }, data) {
    commit('DELETE_PARTICIPANT', data)
  },
  updateParticipant ({ commit }, data) {
    commit('UPDATE_PARTICIPANT', data)
  }
}

const mutations = {
  SET_USER_INFO (state, data) {
    state.user = { ...state.user, ...data }
  },
  SET_CONFERENCE_INFO (state, data) {
    state.conference = { ...state.conference, ...data }
  },
  ADD_PARTICIPANT (state, info) {
    state.participants = { ...state.participants, [info.uid]: info }
  },
  DELETE_PARTICIPANT (state, { key }) {
    Vue.delete(state.participants, key)
  },
  UPDATE_PARTICIPANT (state, info) {
    if (state.participants[info.uid] == null) {
      console.warn('invalid', info)
      return
    }
    Object.assign(state.participants[info.uid], info)
  },
  UPDATE_PANEL_STATE (state, data) {
    state.panelState = { ...state.panelState, ...data }
  },
  APPEND_CHAT_MESSAGE (state, data) {
    state.chatMessages.push(data)
  },
  INIT_AGORA_CLIENT (state, data) {
    state.agoraClient = { ...state.agoraClient, ...data }
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
